export default __webpack_public_path__ + "static/media/Guru-Parampara-08.558ccf97.png";